module.exports = __webpack_public_path__ + "media/images/banner/saibashi/banner-7b5eaaa21d70aaf6e001845fded0e74d.jpg";